/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import {
  START_CREATE_MODEL_FLOW,
  CHOOSE_UPLOAD_REPORT,
  END_CREATE_MODEL_FLOW,
  LEAVE_CREATE_MODEL_FLOW_STEP,
} from '#constants/actionTypes.js';

/*
 * Plain synchronous actions tracking an already-created model's position in the create flow's
 * decision/upload interstitial (HBR-4950 #316). See reducers/ui/createModelFlow/index.js for why
 * this state is ephemeral rather than persisted.
 */
export const startCreateModelFlow = modelId => ({
  type: START_CREATE_MODEL_FLOW,
  meta: { modelId },
});

export const chooseUploadReport = modelId => ({
  type: CHOOSE_UPLOAD_REPORT,
  meta: { modelId },
});

export const endCreateModelFlow = modelId => ({
  type: END_CREATE_MODEL_FLOW,
  meta: { modelId },
});

/*
 * Dispatched from the decision/upload steps' own unmount cleanup (HBR-4950 #316 Copilot finding on
 * PR #344): clears the step only if it's still the one the leaving component rendered, so an
 * ADVANCE to the next step (e.g. "Upload a report" setting 'upload' before navigating away from
 * 'decide') isn't undone by the step being left behind.
 */
export const leaveCreateModelFlowStep = (modelId, step) => ({
  type: LEAVE_CREATE_MODEL_FLOW_STEP,
  meta: { modelId, step },
});
